import api from './api';

export interface PublicProject {
  id: string;
  title: string;
  category: string;
  /** Short teaser text shown on the portfolio card */
  description: string;
  /** Long-form 'About This Project' paragraph shown in the modal */
  fullDescription: string;
  logo?: string;
  image?: string;
  thumbnailUrl?: string;
  url?: string;
  technologies: string[];
  /** Key Features bullet points shown in the modal */
  features: string[];
  featured: boolean;
  order: number;
  isPublished: boolean;
}

export const portfolioService = {
  async getAll(): Promise<PublicProject[]> {
    try {
      const response = await api.get('/portfolio', { params: { published: 'true' } });
      const data = response.data?.data ?? response.data;
      return Array.isArray(data) ? data : [];
    } catch (error) {
      console.error('Failed to fetch portfolio:', error);
      return [];
    }
  },
};
